import fetch from '@giro/shared-utils/fetch.util';

export default async function deleteApiTerminalsRegistrationsIdService(id) {
  return fetch(`terminals/registrations/${id}`, {
    method: 'DELETE',
    ms: 'PDV',
    auth: true,
  });
}
